/**
 * Cal.com Booking Modal Integrator
 *
 * Intercepts links pointing to `#book-a-call` and opens the Cal.com native modal.
 * Handles in-page clicks, deep links (URL hash on arrival), and hashchange events.
 * Uses event delegation so dynamically rendered links (cart drawer, ajax menus,
 * etc.) work without rebinding.
 */
(function () {
  var BOOKING_HASH = 'book-a-call';
  var CAL_LINK = 'leightontaylor/discovery-call';
  var CAL_NAMESPACE = 'discovery-call';

  // Cal.com element-click embed loader.
  (function (C, A, L) { let p = function (a, ar) { a.q.push(ar); }; let d = C.document; C.Cal = C.Cal || function () { let cal = C.Cal; let ar = arguments; if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement("script")).src = A; cal.loaded = true; } if (ar[0] === L) { const api = function () { p(api, arguments); }; const namespace = ar[1]; api.q = api.q || []; if(typeof namespace === "string"){cal.ns[namespace] = cal.ns[namespace] || api;p(cal.ns[namespace], ar);p(cal, ["initNamespace", namespace]);} else p(cal, ar); return;} p(cal, ar); }; })(window, "https://app.cal.com/embed/embed.js", "init");

  Cal("init", CAL_NAMESPACE, { origin: "https://app.cal.com" });
  Cal.ns[CAL_NAMESPACE]("ui", { theme: "light", hideEventTypeDetails: false, layout: "month_view" });
  // Prerender the iframe in the background so first open and reopens within the
  // session are instant. slotsStaleTimeMs (default 60s) is the threshold past
  // which a reopen re-fetches slots and shows the spinner again.
  Cal.ns[CAL_NAMESPACE]("preload", {
    calLink: CAL_LINK,
    type: "modal",
    options: {
      prerenderIframe: true,
      slotsStaleTimeMs: 15 * 60 * 1000,
      iframeForceReloadThresholdMs: 30 * 60 * 1000
    }
  });

  function openCalModal() {
    Cal.ns[CAL_NAMESPACE]("modal", {
      calLink: CAL_LINK,
      config: {
        layout: "month_view",
        useSlotsViewOnSmallScreen: "true",
        theme: "light"
      }
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var anchor = target.closest('a');
    if (!anchor) return;
    var href = anchor.getAttribute('href') || '';
    if (href === '#' + BOOKING_HASH || href.endsWith('#' + BOOKING_HASH)) {
      event.preventDefault();
      openCalModal();
    }
  });

  function openIfHashMatches() {
    if (window.location.hash === '#' + BOOKING_HASH) {
      openCalModal();
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openIfHashMatches);
  } else {
    openIfHashMatches();
  }
  window.addEventListener('hashchange', openIfHashMatches);
})();
